import {observer} from "mobx-react";
import {FieldAutoComplete, FieldSelect} from "../../ui";
import {
    CabinetOption,
    StsCreateFormData,
    StsCreateFormValidation,
    StsCustomerItem,
    StsPrinterItem
} from "../../../store";
import {FieldInput} from "@kroschke/react-ui";
import {StorageTransferReasonDto} from "../../../api/sts";
import {exportStsReason} from "../../../api";


const processOptions = Object
    .keys(StorageTransferReasonDto)
    .map(key => key as StorageTransferReasonDto)
    .filter(key => key !== StorageTransferReasonDto.SECURITY_CODE_ACQUISITION && key !== StorageTransferReasonDto.STORAGE_MERGE_SECURITY_CODE_ACQUISITION)
    .map(key => ({
        label: exportStsReason(key),
        value: key
    }))

interface StsCreateFormProps {
    disabled: boolean
    customers: StsCustomerItem[]
    printers: StsPrinterItem[]
    cabinets: CabinetOption[]
    value: StsCreateFormData
    validation: StsCreateFormValidation
    onBlur: () => any
    onChange: (v: StsCreateFormData) => any
    onSearchCustomer: (v: string) => Promise<StsCustomerItem[]>
    onSearchPrinter: (v: string) => Promise<StsPrinterItem[]>
}

const StsCreateForm = observer(function StsCreateForm({
                                                          disabled,
                                                          customers,
                                                          printers,
                                                          cabinets,
                                                          validation,
                                                          onSearchCustomer,
                                                          onSearchPrinter,
                                                          onChange,
                                                          onBlur,
                                                          value
                                                      }: StsCreateFormProps) {
    return <>
        <div style={{overflow: 'visible', padding: '1em'}}>
            <div className={"columns"}>
                <div className={"column"}>
                    <FieldSelect
                        label={'Prozess'}
                        options={processOptions}
                        value={value.reason}
                        help={validation.reason}
                        invalid={Boolean(validation.reason)}
                        required={true}
                        onChange={e => {
                            onChange({
                                ...value,
                                reason: e as StorageTransferReasonDto
                            })
                            onBlur()
                        }}
                    />
                </div>
                <div className={"column"}>
                    <FieldAutoComplete
                        label={"Kunde"}
                        disabled={disabled}
                        required={true}
                        help={validation.customer}
                        invalid={Boolean(validation.customer)}
                        value={value.customer}
                        options={customers}
                        itemRenderer={c => c.label}
                        search={onSearchCustomer}
                        onBlur={() => !disabled && onBlur()}
                        onChange={(customer: StsCustomerItem | undefined) => {
                            onChange({
                                ...value,
                                customer: customer
                            })
                            onBlur()
                        }}
                    />
                </div>
                <div className={"column"}>
                    <FieldInput
                        disabled={disabled}
                        required={true}
                        maxLength={17}
                        help={validation.vin}
                        invalid={Boolean(validation.vin)}
                        value={value.vin}
                        onBlur={() => !disabled && onBlur()}
                        onChange={fin => onChange({
                            ...value,
                            vin: fin
                        })}
                        inputTransform={(v: string) => {
                            return v.toUpperCase()
                        }}
                        label={"Fahrgestellnummer"}
                    />
                </div>
                <div className={"column"}>
                    <FieldAutoComplete
                        label={"Labeldrucker"}
                        disabled={disabled}
                        required={true}
                        help={validation.printer}
                        invalid={Boolean(validation.printer)}
                        value={value.printer}
                        options={printers}
                        itemRenderer={c => c.label}
                        search={onSearchPrinter}
                        onBlur={() => !disabled && onBlur()}
                        onChange={(printer: StsPrinterItem | undefined) => {
                            onChange({
                                ...value,
                                printer: printer
                            })
                            onBlur()
                        }}
                    />
                </div>
                {Boolean(cabinets && cabinets.length) && <div className={"column"}>
                    <FieldSelect
                        label={'Schrank'}
                        disabled={disabled}
                        options={cabinets}
                        value={value.cabinet}
                        help={validation.cabinet}
                        invalid={Boolean(validation.cabinet)}
                        required={true}
                        onBlur={() => !disabled && onBlur()}
                        onChange={e => {
                            onChange({
                                ...value,
                                cabinet: e
                            })
                            onBlur()
                        }}
                    />
                </div>}
            </div>
        </div>
    </>
})

export {
    StsCreateForm
}
